<template>
    <div>
        <HeaderComponent />
        <main>
            <div class="container" id="error_404">
                <h1 class="desktop_centered desktop_mb64">404 Error</h1>
            </div>
        </main>
        <FooterComponent />
    </div>
</template>

<script>
import { onMounted, defineComponent } from 'vue'
import HeaderComponent from './HeaderComponent.vue'
import FooterComponent from './FooterComponent.vue'

export default defineComponent({
  name: 'AppError',
  components: { HeaderComponent, FooterComponent },
  setup () {
    onMounted(() => {
        document.documentElement.style.setProperty('--font', "'Lato', sans-serif")
    })
    return {}
  }
})
</script>
